import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import {
  TabExploreIcon,
  TabHomeIcon,
  TabPlansIcon,
  TabProfileIcon,
} from './TabIcons';

const TABS: {
  path: string;
  labelKey: string;
  Icon: typeof TabHomeIcon;
  match?: readonly string[];
}[] = [
  { path: '/', labelKey: 'nav.home', Icon: TabHomeIcon },
  {
    path: '/explore',
    labelKey: 'nav.explore',
    Icon: TabExploreIcon,
    match: ['/explore', '/country', '/plan'],
  },
  {
    path: '/my-esims',
    labelKey: 'nav.myEsims',
    Icon: TabPlansIcon,
    match: ['/my-esims', '/esim'],
  },
  {
    path: '/profile',
    labelKey: 'nav.profile',
    Icon: TabProfileIcon,
    match: ['/profile', '/settings', '/notifications', '/invite', '/favorites', '/support', '/wallet', '/orders'],
  },
];

function isTabActive(pathname: string, tabPath: string, match?: readonly string[]) {
  const prefixes = match ?? [tabPath];
  return prefixes.some((p) => (p === '/' ? pathname === '/' : pathname === p || pathname.startsWith(`${p}/`)));
}

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { unreadSupportChat } = useAuth();

  return (
    <nav className="cs-tabbar" aria-label="Main">
      {TABS.map((tab) => {
        const active = isTabActive(location.pathname, tab.path, tab.match);
        const Icon = tab.Icon;
        const label = t(tab.labelKey);
        const showUnread = tab.path === '/profile' && unreadSupportChat > 0;
        return (
          <button
            key={tab.path}
            type="button"
            className={`cs-tabbar__item${active ? ' cs-tabbar__item--active' : ''}`}
            onClick={() => navigate(tab.path)}
            aria-label={label}
            aria-current={active ? 'page' : undefined}
            title={label}
          >
            <span className="cs-tabbar__icon-wrap">
              <Icon className="cs-tabbar__icon" active={active} />
              {showUnread ? (
                <span className="cs-tabbar__badge">{unreadSupportChat > 99 ? '99+' : unreadSupportChat}</span>
              ) : null}
            </span>
            <span className="cs-tabbar__label">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export const TAB_PATHS = TABS.map((t) => t.path);
